export default "__VITE_ASSET__$HNnQRvU__"